<template>
  <div class="head" :style="{width: headWidth, 'padding-right': padding}">
    <div class="head-left">
      <img :src="logo" class="head-icon" />
      <span class="head-title">{{title}}</span>
      <img src="../../assets/head-triangle.png" class="head-triangle" />
    </div>
    <div class="head-more" v-if="isShowMore" @click="lookMore">
      <img src="../../assets/more-icon.png" class="head-more-icon" />
      <div class="head-more-text">更多</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: null
    };
  },
  props: {
    title: String,
    icon: String,
    moreTitle: String,
    isShowMore: {
      type: Boolean,
      default: true
    },
    headWidth: String,
    padding: String
  },
  created() {
    switch (this.icon) {
      case "massage":
        this.logo = require("../../assets/massage-icon.png");
        break;
      case "industry":
        this.logo = require("../../assets/industry-icon.png");
        break;
      case "new":
        this.logo = require("../../assets/new-icon.png");
        break;
      case "features":
        this.logo = require("../../assets/features-icon.png");
        break;
    }
  },
  methods: {
    lookMore() {
      this.$http
        .get(
          `/open/cms/category?filter=name||eq||${this.moreTitle}&filter=type||eq||nav`
        )
        .then(res => {
          if (res.data.data[0].parentId) {
            this.$http
              .get(
                `/open/cms/category?filter=id||eq||${res.data.data[0].parentId}`
              )
              .then(data => {
                this.$store.commit("eidtBreadcrumb", data.data.data[0].id);
                this.$router.push({
                  name: "articleList",
                  query: {
                    selectMenuId: data.data.data[0].id,
                    type: "list",
                    selectMoreId: res.data.data[0].id
                  }
                });
              });
          } else {
            this.$store.commit("eidtBreadcrumb", res.data.data[0].id);
            this.$router.push({
              name: "articleList",
              query: {
                selectMenuId: res.data.data[0].id,
                type: "list"
              }
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  display: block;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #e6e6e6;
  background: white;
  &-left {
    position: relative;
    float: left;
    width: 120px;
    height: 48px;
    background-color: #ff8022;
    color: white;
  }
  &-triangle {
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  &-icon {
    width: 20px;
    height: 20px;
    margin-left: 16px;
    vertical-align: middle;
  }
  &-title {
    font-size: 16px;
    vertical-align: middle;
    padding-left: 4px;
  }
  &-more {
    float: right;
    height: 48px;
    font-size: 12px;
    color: #ff6656;
    cursor: pointer;
    &-icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      vertical-align: middle;
    }
    &-text {
      display: inline-block;
      margin-top: 2px;
      vertical-align: middle;
    }
  }
}
</style>
